import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { browserHistory as history } from 'react-router';
import { connect } from 'react-redux';

import Anchor from '@zacousticrepo/grommet-v1-custom/components/Anchor';
import Button from '@zacousticrepo/grommet-v1-custom/components/Button';
import Box from '@zacousticrepo/grommet-v1-custom/components/Box';
import Heading from '@zacousticrepo/grommet-v1-custom/components/Heading';
import FormField from '@zacousticrepo/grommet-v1-custom/components/FormField';
import LoginForm from '@zacousticrepo/grommet-v1-custom/components/LoginForm';
import Paragraph from '@zacousticrepo/grommet-v1-custom/components/Paragraph';
import TextInput from '@zacousticrepo/grommet-v1-custom/components/TextInput';
import CheckBox from '@zacousticrepo/grommet-v1-custom/components/CheckBox';
import LoadingControl from '../components/LoadingControl';

import {
    login,
    setForgotPassword,
    sendPasswordResetEmail,
    loadTemporaryLink,
    resetPassword,
    pollSso
} from '../sessionActions';

import { SESSION_LOAD } from '../actionDefinitions';
import { ifNull, pageLoaded } from '../utils';
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            password1: '',
            password2: '',
            ssoEmail: '',
            clientHasSso: false,
            isSsoLogin: true
        };

        this._onSubmit = this._onSubmit.bind(this);
        this._onForgotPassword = this._onForgotPassword.bind(this);
        this._onSendPasswordReset = this._onSendPasswordReset.bind(this);
        this._onResetPassword = this._onResetPassword.bind(this);
        this._handleFormFieldUpdate = this._handleFormFieldUpdate.bind(this);
        this._returnToLogin = this._returnToLogin.bind(this);
        this._onKeyDownEvent = this._onKeyDownEvent.bind(this);
        this._onSsoLogin = this._onSsoLogin.bind(this);
        this._updateSSoEmail = this._updateSSoEmail.bind(this);
        this._toggleUseSsoLogin = this._toggleUseSsoLogin.bind(this);
    }

    componentWillMount() {
        const {
            params: { oLoginId }
        } = this.props;

        const {
            params: { temporaryLinkText }
        } = this.props;

        if (temporaryLinkText) {
            this.setState({ isSsoLogin: false });
        } else if (oLoginId) {
            const userId = `${oLoginId}@fb.com`;
            this.props.dispatch(pollSso(userId));
        }
    }

    componentDidMount() {
        pageLoaded('Zacoustic - Login');
        if (this.props.params.temporaryLinkText)
            this.props.dispatch(loadTemporaryLink(this.props.params.temporaryLinkText));
        this.updateControlState(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateControlState(nextProps);
    }

    componentWillUnmount() { }

    updateControlState(propsToUse) {
        const { desktopUserName, desktopAttemptLogin } = propsToUse;
        if (desktopAttemptLogin && desktopUserName)
            this.props.dispatch(login(desktopUserName, '', true, '/SystemDashboard', true));
    }

    _onForgotPassword() {
        this.props.dispatch({
            type: SESSION_LOAD,
            payload: { forgotPasswordResult: undefined, resetError: undefined }
        });
        this.props.dispatch(setForgotPassword(!this.props.forgotPassword));
    }

    _onSendPasswordReset() {
        this.props.dispatch({ type: SESSION_LOAD, payload: { processingRequest: true } });
        this.props.dispatch(sendPasswordResetEmail(this.state.userName));
    }

    _onResetPassword() {
        this.props.dispatch(
            resetPassword(this.props.params.temporaryLinkText, this.state.password1, this.state.password2)
        );
    }

    _returnToLogin() {
        history.push('/login');
    }

    _onKeyDownEvent(event) {
        if (event.key === 'Enter') {
            if (event.target.name === 'userName') this._onSendPasswordReset();
            else this._onResetPassword();
        }
    }

    _handleFormFieldUpdate({ target }) {
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [target.name]: value });
    }

    _onSubmit({ username, password, rememberMe }) {
        this.props.dispatch({
            type: SESSION_LOAD,
            payload: { userNameFromReset: undefined, passwordFromReset: undefined }
        });
        this.props.dispatch(login(username, password, rememberMe, '/SystemDashboard', false));
    }

    _onSsoLogin() {
        window.open(
            'https://fb.okta.com/app/facebookproduction_zacousticprod_1/exk7ak6j07vxHr6m4357/sso/saml',
            '_self'
        );
    }

    _updateSSoEmail({ target }) {
        this.setState({ ssoEmail: target.value });
    }

    _toggleUseSsoLogin() {
        const { isSsoLogin } = this.state;
        this.setState({ isSsoLogin: !isSsoLogin });
    }

    render() {
        const {
            error,
            message,
            processingRequest,
            forgotPassword,
            forgotPasswordResult,
            resetPasswordResult,
            resetError,
            isFetching,
            temporaryLink,
            params: { temporaryLinkText }
        } = this.props;
        const { isSsoLogin, clientHasSso } = this.state;
        if (clientHasSso && isSsoLogin) {
            const samlMainNode = (
                <Box full={true} direction="row">
                    <Box
                        align="center"
                        pad="none"
                        size="large"
                        style={{ height: '100vh', maxHeight: '100%', marginLeft: 'auto' }}>
                        <Box style={{ width: '100%', height: '85px', marginTop: 'auto' }}>
                            <Box
                                style={{
                                    height: '131px',
                                    width: '129px',
                                    margin: 'auto',
                                    backgroundImage: `url(${`../../../../Assets/Images/logo2022.png`})`
                                }}></Box>
                        </Box>
                        <Paragraph style={{ width: '250px' }}>
                            <b>Notice:</b> Users with facebook.com email addresses must use SSO log in option.
                        </Paragraph>
                        <Button
                            className="create-account"
                            label="Log In"
                            onClick={this._onSsoLogin}
                            primary={true}
                        />
                        <div style={{ margin: '20px 0' }}>
                            <CheckBox
                                checked={isSsoLogin}
                                onChange={this._toggleUseSsoLogin}
                                label="Use SSO Login"
                                toggle={true}
                            />
                        </div>
                        <Box
                            direction="row"
                            size="small"
                            pad={{ horizontal: 'medium', vertical: 'small' }}
                            style={{ marginBottom: 'auto' }}>
                            <span>&copy; {new Date().getFullYear()} Zacoustic</span>
                        </Box>
                    </Box>
                    <Box style={{ width: '50%', height: '100%' }}>
                        <Box
                            pad="large"
                            justify="center"
                            align="center"
                            style={{
                                margin: 'auto auto auto 50px',
                                height: '100%',
                                width: '55%',
                                backgroundImage: `url(${'../../../../Assets/Images/LoginPicture2.png'})`
                            }}></Box>
                    </Box>
                </Box>
            );

            return samlMainNode;
        }
        else {
            let mainNode;

            let userNameFromReset = ifNull(this.props.userNameFromReset);
            let passwordFromReset = ifNull(this.props.userNameFromReset);

            if (forgotPassword) {
                let resultNode;
                if (forgotPasswordResult)
                    resultNode = (
                        <Paragraph align="center" className={resetError ? 'errorText' : ''}>
                            {forgotPasswordResult}
                        </Paragraph>
                    );

                const buttonAction = !processingRequest && this._onSendPasswordReset;
                const buttonText = processingRequest ? 'Sending...' : 'Reset Password';
                const cancelButtonAction = !processingRequest && this._onForgotPassword;
                const cancelButtonText = forgotPasswordResult ? (resetError ? 'Cancel' : 'Return') : 'Cancel';

                mainNode = (
                    <Box size="large" pad="medium">
                        <Box>
                            <Heading tag="h1" strong={true}>
                                Zacoustic
                            </Heading>
                            <Heading tag="h2">Forgot Password</Heading>
                            {resultNode}
                        </Box>
                        {((forgotPasswordResult && resetError) || !forgotPasswordResult) && (
                            <Box pad={{ vertical: 'medium' }}>
                                <FormField label="Enter Your Username or Email Address">
                                    <TextInput
                                        name="userName"
                                        disabled={processingRequest}
                                        value={this.state.userName}
                                        onDOMChange={this._handleFormFieldUpdate}
                                        onKeyDown={this._onKeyDownEvent}
                                    />
                                </FormField>
                            </Box>
                        )}
                        <Box pad={{ between: 'small' }} direction="row">
                            {((forgotPasswordResult && resetError) || !forgotPasswordResult) && (
                                <Button label={buttonText} primary={true} onClick={buttonAction} />
                            )}
                        </Box>
                        <div style={{ margin: '20px auto' }}>
                            {!processingRequest && <Button style={{ width: '200px' }}
                                label={cancelButtonText} secondary={true} onClick={cancelButtonAction} />}
                        </div>
                    </Box>
                );
            } else if (temporaryLinkText) {
                let resultNode;
                if (resetPasswordResult) {
                    resultNode = (
                        <Paragraph align="center" className={resetError ? 'errorText' : ''}>
                            {resetPasswordResult}
                        </Paragraph>
                    );
                    if (!resetError) {
                        this.props.dispatch({
                            type: 'SESSION_LOAD',
                            payload: {
                                message: resetPasswordResult,
                                temporaryLinkText: undefined,
                                resetError: undefined,
                                resetPasswordResult: undefined
                            }
                        });
                        this._returnToLogin();
                    }
                }

                const buttonAction = !processingRequest && this._onResetPassword;
                const buttonText = processingRequest ? 'Sending...' : 'Reset Password';
                const cancelButtonText = resetPasswordResult ? (resetError ? 'Return' : 'Cancel') : 'Cancel';

                mainNode = (
                    <Box size="large" pad="medium">
                        <Box>
                            <Heading tag="h1" strong={true}>
                                Zacoustic
                            </Heading>
                            <Heading tag="h2">Reset Password</Heading>
                            {resultNode}
                        </Box>
                        {temporaryLink && ((resetPasswordResult && resetError) || !resetPasswordResult) && (
                            <Box pad={{ vertical: 'medium' }}>
                                <FormField label="Enter New Password">
                                    <TextInput
                                        name="password1"
                                        type="password"
                                        value={this.state.password1}
                                        onDOMChange={this._handleFormFieldUpdate}
                                        onKeyDown={this._onKeyDownEvent}
                                    />
                                </FormField>
                                <FormField label="Reenter New Password">
                                    <TextInput
                                        name="password2"
                                        type="password"
                                        value={this.state.password2}
                                        onDOMChange={this._handleFormFieldUpdate}
                                        onKeyDown={this._onKeyDownEvent}
                                    />
                                </FormField>
                            </Box>
                        )}
                        <Box pad={{ between: 'small' }} direction="row">
                            {temporaryLink && ((resetPasswordResult && resetError) || !resetPasswordResult) && (
                                <Button label={buttonText} primary={true} onClick={buttonAction} />
                            )}
                            {!processingRequest && <Button label={cancelButtonText} onClick={this._returnToLogin} />}
                        </Box>
                    </Box>
                );
            } else {
                const forgotPasswordLink = <Anchor onClick={this._onForgotPassword}>Forgot password?</Anchor>;

                let effectiveMessage = message;
                if (this.props.params.logoutMessage) {
                    history.push('/login');
                    effectiveMessage = this.props.params.logoutMessage + (message ? `; ${message}` : '');
                    this.props.dispatch({ type: SESSION_LOAD, payload: { message: effectiveMessage } });
                }

                // Rewrite error text that comes from the Microsoft Identity API.
                let effectiveError = error;
                if (effectiveError && effectiveError === 'The user name or password is incorrect.')
                    effectiveError = 'The username or password is incorrect';

                mainNode = (
                    <LoginForm
                        align="start"
                        onSubmit={this._onSubmit}
                        errors={[effectiveError]}
                        usernameType="text"
                        rememberMe={true}
                        forgotPassword={forgotPasswordLink}
                        secondaryText={effectiveMessage}
                        defaultValues={{ rememberMe: true }}
                        username={userNameFromReset}
                        password={passwordFromReset}
                    />
                );
            }

            return !isFetching ? (
                <Box full={true} direction="row">
                    <Box
                        align="center"
                        pad="none"
                        size="large"
                        style={{ height: '100vh', maxHeight: '100%', marginLeft: 'auto' }}>
                        <Box style={{ width: '100%', height: '313px', marginTop: 'auto' }}>
                            <Box
                                style={{
                                    height: '131px',
                                    width: '129px',
                                    margin: 'auto',
                                    backgroundImage: `url(${`../../../../Assets/Images/logo2022.png`})`
                                }}></Box>
                        </Box>
                        {clientHasSso &&
                            <Paragraph style={{ width: '250px' }}>
                                <b>Notice:</b> Users with facebook.com email addresses must use SSO log in option.
                            </Paragraph>
                        }
                        {mainNode}
                        {clientHasSso &&
                            <CheckBox
                                checked={isSsoLogin}
                                onChange={this._toggleUseSsoLogin}
                                label="Use SSO Login"
                                toggle={true}
                            />
                        }
                        <Box
                            direction="row"
                            size="small"
                            pad={{ horizontal: 'medium', vertical: 'small' }}
                            style={{ marginBottom: 'auto' }}>
                            <span>&copy; {new Date().getFullYear()} Zacoustic</span>
                        </Box>
                    </Box>
                    <Box style={{ width: '50%', height: '100%' }}>
                        <Box
                            pad="large"
                            justify="center"
                            align="center"
                            style={{
                                margin: 'auto auto auto 50px',
                                height: '100%',
                                width: '55%',
                                backgroundImage: `url(${'../../../../Assets/Images/LoginPicture2.png'})`
                            }}></Box>
                    </Box>
                </Box>
            ) : (
                <Box full={true} direction="row">
                    <Box
                        align="center"
                        pad="none"
                        size="large"
                        style={{ height: '100vh', maxHeight: '100%', marginLeft: 'auto' }}>
                        <Box style={{ width: '100%', height: '85px', marginTop: 'auto' }}>
                            <Box
                                style={{
                                    height: '131px',
                                    width: '129px',
                                    margin: 'auto',
                                    backgroundImage: `url(${`../../../../Assets/Images/logo2022.png`})`
                                }}></Box>
                        </Box>
                        <LoadingControl />
                        <Box
                            direction="row"
                            size="small"
                            pad={{ horizontal: 'medium', vertical: 'small' }}
                            style={{ marginBottom: 'auto' }}>
                            <span>&copy; {new Date().getFullYear()} Zacoustic</span>
                        </Box>
                    </Box>
                    <Box style={{ width: '50%', height: '100%' }}>
                        <Box
                            pad="large"
                            justify="center"
                            align="center"
                            style={{
                                margin: 'auto auto auto 50px',
                                height: '100%',
                                width: '55%',
                                backgroundImage: `url(${'../../../../Assets/Images/LoginPicture2.png'})`
                            }}></Box>
                    </Box>
                </Box>
            );
        }
    }
}

Login.propTypes = {
    dispatch: PropTypes.func.isRequired,
    error: PropTypes.object,
    message: PropTypes.string,
    forgotPassword: PropTypes.bool,
    forgotPasswordResult: PropTypes.string,
    temporaryLink: PropTypes.object,
    resetPasswordResult: PropTypes.string
};

const select = state => ({ ...state.session });

export default connect(select)(Login);
